export default (tourCriteria) => {
    const tourCriteriaJson = {};
    const element = tourCriteria.get('isExclusive');
    if (element) {
        tourCriteriaJson.isExclusive = 1;
    }
    return tourCriteriaJson;
};